'use client'

import React from 'react'
import * as TooltipRadix from '@radix-ui/react-tooltip'

interface TooltipRadixProps {
  trigger: React.ReactNode
  children: React.ReactNode
  open?: boolean
  onOpenChange?: (open: boolean) => void
}

const Tooltip = (props: TooltipRadixProps) => {
  return (
    <TooltipRadix.Provider>
      <TooltipRadix.Root open={props.open} onOpenChange={props.onOpenChange}>
        <TooltipRadix.Trigger asChild>{props.trigger}</TooltipRadix.Trigger>
        <TooltipRadix.Portal>
          <TooltipRadix.Content className="z-50">
            <div className="max-w-[80vw] rounded-md bg-black px-2 py-1 text-white shadow-md sm:max-w-[31.25rem]">
              {props.children}
            </div>
          </TooltipRadix.Content>
        </TooltipRadix.Portal>
      </TooltipRadix.Root>
    </TooltipRadix.Provider>
  )
}

export default Tooltip
